<template>
  <div class="header-banner " :class="[gameName,{'loged':gameID}]"></div>
</template>
<script>
export default {
  props: {
    gameID: [String,Number],
  },
  computed: {
    gameName() {
      const gameMap = {
        poker:["1000016"],
        uno: ["1000000", "1024", "2048", "2000018"],
        p10: [
           "1019",
            "1014",
            "1015",
            "1016",
            "1017",
            "1018",
            "1019",
            "1020",
            "1021",
            "1022",
            "2000013",
            "2000014",
            "2000016",
            "2000019",
            "2000023",
            "2000024",
            "2000027"
        ],
        uno2: ["2000007", "2000017", "1000014"],
        skb: ['2000001', '2000004', '2000005', '1000008']
      };
      for (const [name, ids] of Object.entries(gameMap)) {
        if (ids.includes(String(this.gameID))) {
          return name;
        }
      }
      return "";
    },
  },
};
</script>
<style lang="less" scoped>
.header-banner {
  width: 100%;
  height: 4.27rem;
  background: url("../../assets/v_mgs.png") no-repeat center center;
  background-size: cover;
  margin: 0;
  &.uno {
    background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_uno.png") no-repeat center center ,url("../../assets/v_mgs.png") no-repeat center center;
    background-size: cover;
  }
  &.p10 {
    background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_p10.png") no-repeat center center, url("../../assets/v_mgs.png") no-repeat center center;
    background-size: cover;
  }
  &.uno2 {
    background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_unowonder.png") no-repeat center  center, url("../../assets/v_mgs.png") no-repeat center center;
    background-size: cover;
  }
  &.skb {
    background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_skb.png") no-repeat center center,url("../../assets/v_mgs.png") no-repeat center center;
    background-size: cover;
  }
}

@media screen and (orientation: landscape) { 
  // 横屏样式

  .header-banner {
    width: 40% !important;
    height: 100% !important;
    background: url("../../assets/mgs.png") no-repeat center center;
    background-size: cover;

    &.uno {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/uno.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.p10 {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/p10.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.uno2 {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/unowonder.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.skb {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/skb.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }

    &.uno.loged {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/uno_active.png") no-repeat center
        center ,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.p10.loged {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/p10_active.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.uno2.loged {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/unowonder_active.png") no-repeat center
        center ,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.skb.loged {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/skb_active.png") no-repeat center center,url("../../assets/mgs.png") no-repeat center center;
      background-size: cover;
    }
  }
  .main-container {
    flex: 1;
  }
}
//  适配ipad
@media screen and (min-width: 600px) and (orientation: portrait) {
  .header-banner {
    background: url("../../assets/PAD-mgs.png") no-repeat center center;
    background-size: cover;

    &.uno {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_PAD-UNO.png") no-repeat center
        center,url("../../assets/PAD-mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.p10 {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_PAD-P10.png") no-repeat center
        center,url("../../assets/PAD-mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.uno2 {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_PAD-UNO2.png") no-repeat center
        center,url("../../assets/PAD-mgs.png") no-repeat center center;
      background-size: cover;
    }
    &.skb {
      background: url("https://store-f2e.mattel163.com/gamecenter-core-uploads/prod/v_PAD-SKB.png") no-repeat center
        center,url("../../assets/PAD-mgs.png") no-repeat center center;
      background-size: cover;
    }
  }
}
</style>
